// src/components/zones/ThalwegTrench/ElectricEel.jsx
import React from 'react';
import '../../../css/float.css';
import '../../../css/glow.css';

export default function ElectricEel({
  theme = 'light',
  width = 100,
  highlight = false,
  onClick,
}) {
  if (process.env.REACT_APP_SHOW_ELECTRIC_EEL !== 'true') return null;

  const eelUrl = '/images/animals/80_100m/predator/electric_eel_head.png';

  const classes = [
    'bob',
    theme === 'light' ? 'glow-light' : 'glow-dark',
    highlight ? 'ring-4 ring-yellow-300 rounded-full' : '',
  ].filter(Boolean).join(' ');

  return (
    <img
      src={eelUrl}
      alt="Electric Eel"
      draggable={false}
      onClick={onClick}
      className={classes}
      style={{ width: `${width}px`, display: 'block', cursor: onClick ? 'pointer' : 'default' }}
    />
  );
}
